export default {
    container: {
        background: '#fff',
        minHeight: '100%',
    },
    editPanel: {
        padding: 0,
        width: '100%',
        minHeight: '100%',
        fontSize: '1.2rem',
    },
    sendMessageButton: {
      margin: '2.8rem 0 2.8rem .8rem',
      borderRadius: '.4rem'
    },
}
